import { render, staticRenderFns } from "./CampaignGeneral.vue?vue&type=template&id=5f951058&"
import script from "./CampaignGeneral.vue?vue&type=script&lang=js&"
export * from "./CampaignGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports